export const OUTREACH_AGGREGATE_TYPE = 'report:outreach-aggreage';

export const VISIT_GROUP = 'Visit';
export const CF_VISIT_GROUP = 'CfVisit';
export const CLIENT_GROUP = 'Client';
export const LOCATION_GROUP = 'Location';
export const VISIT_TRACK_GROUP = 'VisitTrack';

export const VisitTrackColumns = [
  {
    name: 'trackResult_household',
    label: '# in Household'
  },
  {
    name: 'trackResult_weight',
    label: 'Total weight'
  },
  {
    name: 'trackResult_items',
    label: 'Total Items'
  },
  {
    name: 'trackResult_usage',
    label: 'Total Usage'
  }
];
